module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.merchandises) ? _c('div', {
    staticStyle: {
      "background-color": "white"
    },
    attrs: {
      "id": "merchandises"
    }
  }, [_c('nav', {
    staticClass: "bar bar-nav"
  }, [(!_vm.isWapp) ? _c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n    ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "margin-bottom": "2rem",
      "background-color": "white",
      "overflow-y": "auto",
      "overflow-x": "hidden"
    }
  }, [(_vm.merchandises) ? _c('div', {
    staticClass: "page-detail"
  }, [_c('div', {
    staticClass: "item-subtitle",
    staticStyle: {
      "color": "#0894ec"
    }
  }, [(_vm.merchandises.showpromotion && _vm.merchandises.showpromotion.length > 0) ? _c('div', {
    staticClass: "item-title-row"
  }, [_c('span', {
    staticStyle: {
      "color": "slateblue",
      "font-size": "0.6rem",
      "margin-left": "0.2rem"
    }
  }, [_vm._v("参与促销：\n            "), _vm._l((_vm.merchandises.showpromotion), function(proo, index) {
    return _c('span', [(proo.type === 1) ? _c('span', [_vm._v("\n               " + _vm._s(index + 1) + ": " + _vm._s(proo.description) + "\n              ")]) : _vm._e()])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "content-block goods-card",
    staticStyle: {
      "font-size": "0.6rem",
      "margin-bottom": "1.5rem"
    }
  }, [_vm._l((_vm.merchandises._titleList), function(title) {
    return _c('span', {
      staticStyle: {
        "margin-left": "0.3rem"
      }
    }, [(title.columnName === 'TVInfo') ? _c('span', [_vm._v(_vm._s(title.valueText.TLNo))]) : _c('span', [_vm._v(_vm._s(title.valueText))])])
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.sessionInfo.customerInfo && _vm.sessionInfo.customerInfo.ssoFlag === 1) ? _c('strong', {
    staticStyle: {
      "color": "#4479B4",
      "font-size": "0.9rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMax))]) : _c('strong', {
    staticStyle: {
      "color": "#4479B4",
      "font-size": "0.9rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.priceMin))]), _vm._v(" "), (_vm.merchandises.cataloguePrice) ? _c('del', {
    staticStyle: {
      "font-size": "0.5rem"
    }
  }, [_vm._v("¥" + _vm._s(_vm.merchandises.cataloguePrice))]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    staticClass: "content-block"
  }, [_c('div', {
    staticClass: "buttons-row"
  }, [_c('a', {
    staticClass: "tab-link  button",
    attrs: {
      "href": "#tab-introduce"
    }
  }, [_vm._v("产品介绍")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link active button",
    attrs: {
      "href": "#tab-detail"
    }
  }, [_vm._v("详情")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab-qualityCommitment"
    }
  }, [_vm._v("质量承诺")]), _vm._v(" "), _c('a', {
    staticClass: "tab-link button",
    attrs: {
      "href": "#tab-comments"
    }
  }, [_vm._v("评论(" + _vm._s(_vm.Comments.length) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-introduce"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduces)
    }
  }), _vm._v(" "), (_vm.merchandises.manualFileName) ? _c('div', [(_vm.introduces === '') ? _c('p', [_vm._v(_vm._s(_vm.merchandises.description))]) : _vm._e(), _vm._v(" "), (_vm.merchandises.manualFileName != '') ? _c('p') : _vm._e(), (_vm.merchandises.manualFileName.split(';').length === 1) ? _c('p', [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.manualurl + _vm.merchandises.manualFileName + _vm.attr
    }
  }, [_vm._v("查看商品手册")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.merchandises.manualFileName.split(';')), function(manualFileName, index) {
    return (_vm.merchandises.manualFileName.split(';').length !== 1) ? _c('p', [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.manualurl + manualFileName + _vm.attr
      }
    }, [_vm._v("查看商品手册" + _vm._s(index + 1))])]) : _vm._e()
  }), _vm._v(" "), _c('p')], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab ",
    attrs: {
      "id": "tab-qualityCommitment"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.qualityCommitment)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tab active list-block",
    staticStyle: {
      "margin-top": "0rem"
    },
    attrs: {
      "id": "tab-detail"
    }
  }, [_vm._l((_vm.merchandises._attributesList), function(merchandise) {
    return _c('div', {
      staticStyle: {
        "margin-bottom": "0.3rem",
        "margin-top": "1.2rem",
        "margin-left": "0.2rem",
        "margin-right": "0.2rem"
      }
    }, [(merchandise.valueText) ? _c('div', [(merchandise.columnName === 'STRSite' && merchandise.valueText.indexOf('；') !== -1) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "padding-top": "0px"
      }
    }, _vm._l((merchandise.valueText.split('；')), function(value) {
      return _c('span', [_vm._v("\n                       " + _vm._s(value) + "\n                        "), _c('br')])
    }), 0), _vm._v(" "), _vm._m(0, true)]) : (merchandise.columnName === 'AdditionalParameters' && merchandise.valueText.indexOf('；') !== -1) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "padding-top": "0px"
      }
    }, _vm._l((merchandise.valueText.split('；')), function(value) {
      return _c('span', [_vm._v("\n                       " + _vm._s(value) + "\n                        "), _c('br')])
    }), 0), _vm._v(" "), _vm._m(1, true)]) : _c('div', [(merchandise.displayable && merchandise.valueText.length > 60) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名' && merchandise.valueText.length > 60 && merchandise.valueText.length < 80) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 40)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(40, 60)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(60)) + "\n                        ")])]) : (merchandise.label === '基因别名' && merchandise.valueText.length >= 80 && merchandise.valueText.length < 100) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 40)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(40, 60)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(60, 80)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(80)) + "\n                        ")])]) : (merchandise.label === '基因别名' && merchandise.valueText.length >= 100) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 40)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(40, 60)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(60, 80)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(80, 100)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(100)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText) + "\n                        ")])]), _vm._v(" "), (merchandise.label === '基因别名') ? _c('div', {
      staticStyle: {
        "margin-top": "7rem"
      }
    }, [_c('hr', {
      staticStyle: {
        "height": "0.06rem",
        "border": "0.06rem",
        "background-color": "#B4B4B4"
      }
    })]) : _c('div', {
      staticStyle: {
        "margin-top": "11rem"
      }
    }, [_c('hr', {
      staticStyle: {
        "height": "0.06rem",
        "border": "0.06rem",
        "background-color": "#B4B4B4"
      }
    })])]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length > 45 && merchandise.valueText.length <= 60) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名') ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 39)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(39, 58)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(58)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(2, true)]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length > 30 && merchandise.valueText.length <= 45) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名' && merchandise.valueText.length <= 38) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19)) + "\n                        ")])]) : (merchandise.label === '基因别名' && merchandise.valueText.length > 38) ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19, 38)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(38)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "8rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(3, true)]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length > 16 && merchandise.valueText.length <= 30) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), (merchandise.label === '基因别名') ? _c('span', {
      staticStyle: {
        "float": "right",
        "width": "9rem"
      }
    }, [_c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(0, 19)) + "\n                        ")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(merchandise.valueText.substring(19)) + "\n                        ")])]) : _c('span', {
      staticStyle: {
        "float": "right",
        "width": "10rem"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(4, true)]) : _vm._e(), _vm._v(" "), (merchandise.displayable && merchandise.valueText.length <= 16) ? _c('div', [_c('span', {
      staticStyle: {
        "color": "#00469A"
      }
    }, [_vm._v(_vm._s(merchandise.label))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right"
      }
    }, [_vm._v(_vm._s(merchandise.valueText))]), _vm._v(" "), _vm._m(5, true)]) : _vm._e()])]) : _vm._e()])
  }), _vm._v(" "), (_vm.merchandises._cycle) ? _c('div', [_c('span', {
    staticStyle: {
      "color": "#00469A"
    }
  }, [_vm._v(_vm._s(_vm.merchandises._cycle.label))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_vm._v(_vm._s(_vm.merchandises._cycle.valueText))])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "tab",
    staticStyle: {
      "margin-left": "0rem"
    },
    attrs: {
      "id": "tab-comments"
    }
  }, [_c('div', {
    staticClass: "list-block media-list"
  }, [(_vm.Comments.length > 0) ? _c('ul', _vm._l((_vm.Comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "item-content"
    }, [_vm._m(6, true), _vm._v(" "), _c('div', {
      staticClass: "item-inner"
    }, [_c('div', {
      staticClass: "item-title-row"
    }, [_c('div', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(comment.customerName))]), _vm._v(" "), _c('div', {
      staticClass: "item-after"
    }, [_vm._v(_vm._s(comment.createDT.split(' ')[0]))])]), _vm._v(" "), _c('div', _vm._l((comment.commentLevel), function(index) {
      return _c('span', {
        staticClass: "icon icon-star star",
        staticStyle: {
          "background-color": "yellow",
          "margin-left": "0.2rem"
        }
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "item-text"
    }, [_vm._v(_vm._s(comment.comments))])])])])
  }), 0) : _c('div', [_vm._v("\n                  暂无用户评价！\n                ")])])])])])]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "bar  bar-tab",
    style: ({
      'height': _vm.emkt.leaveSpaceForFullScreen ? '85px' : '2.5rem'
    })
  }, [_c('div', {
    staticClass: "item-media"
  }, [(_vm.hasLogin) ? _c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "float": "left",
      "margin-left": "2rem"
    }
  }, [_c('span', {
    staticClass: "icon icon-message",
    on: {
      "click": function($event) {
        return _vm.toMessage(_vm.merchandises.merchandiseLabel)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label",
    staticStyle: {
      "width": "1.5rem"
    },
    on: {
      "click": function($event) {
        return _vm.toMessage(_vm.merchandises.merchandiseLabel)
      }
    }
  }, [_vm._v("客服")]), _vm._v(" "), (_vm.curMessageSession.leaveMessageStatus === 3) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v("1")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-item",
    staticStyle: {
      "width": "10rem"
    },
    on: {
      "click": _vm.gotoCart
    }
  }, [_c('span', {
    staticClass: "icon icon-cart"
  }), _vm._v(" "), _c('span', {
    staticClass: "tab-label"
  }, [_vm._v("购物车")]), _vm._v(" "), (_vm.getTotalGoodsNum > 0) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.getTotalGoodsNum))]) : _vm._e()]), _vm._v(" "), (_vm.QuoteStatus === false) ? _c('section', {
    staticClass: "gotopay"
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    },
    on: {
      "click": function($event) {
        return _vm.addCartList(_vm.merchandises)
      }
    }
  }, [_vm._v("加入购物车")])]) : _c('section', {
    staticClass: "gotopay",
    staticStyle: {
      "background-color": "gray"
    }
  }, [_c('span', {
    staticClass: "gotopay_button_style",
    staticStyle: {
      "padding-top": "0rem"
    }
  }, [_vm._v("加入购物车")])])])])]) : _c('div', {
    staticStyle: {
      "margin-top": "11rem",
      "text-align": "center",
      "font-size": "200%"
    }
  }, [_c('div', [_vm._v("\n   此商品已经下架！\n  ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "11rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3.8rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "3rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-top": "1.5rem"
    }
  }, [_c('hr', {
    staticStyle: {
      "height": "0.06rem",
      "border": "0.06rem",
      "background-color": "#B4B4B4"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-media"
  }, [_c('img', {
    attrs: {
      "src": "/emktResources/resocurces/img/user.jpg",
      "width": "50"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f16b532","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Detail/Merchandises.vue
// module id = 1536
// module chunks = 8